import { createFileRoute, redirect } from '@tanstack/react-router'

import { programLinkOptions } from '~/features/dashboard/components/layout'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/',
)({
  beforeLoad: async ({ location }) => {
    // Try to extract program from the current path
    const match = location.pathname.match(/\/dashboard\/(weight-loss|urgent-care)/);
    const program = match ? match[1] : undefined;
    throw redirect(programLinkOptions(program));
  },
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Error Loading Dashboard Page</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
})

